export default __webpack_public_path__ + "static/media/14.90c7a24b.png";